export default __webpack_public_path__ + "static/media/pink_studen_dashboard_bg.688ae022.jpg";